import redEmptyRoom from './redEmptyRoom.jpg'
import redEmptyRoomSmall from './redEmptyRoom_small.jpg'
import ua1 from './ua1.jpg'
import ua2 from './ua2.jpg'
import ua3 from './ua3.jpg'
import ua4 from './ua4.jpg'
import ua5 from './ua5.jpg'
import ua6 from './ua6.jpg'
import ua7 from './ua7.jpg'
import en1 from './en1.jpg'
import en2 from './en2.jpg'
import en3 from './en3.jpg'
import en4 from './en4.jpg'
import en5 from './en5.jpg'
import en6 from './en6.jpg'
import en7 from './en7.jpg'

export default {
  background: redEmptyRoom,
  bgThumbnail: redEmptyRoomSmall,
  ua: [ua1, ua2, ua3, ua4, ua5, ua6, ua7],
  en: [en1, en2, en3, en4, en5, en6, en7],
}
